import { apiInstance } from './api';

export interface OnboardingStep {
  id: string;
  name: string;
  description: string;
  redirectUrl: string;
  completed: boolean;
  completedAt: string | null;
}

export interface OnboardingData {
  steps: OnboardingStep[];
  completionPercentage: number;
  totalSteps: number;
  completedSteps: number;
}

export const getOnboardingSteps = async (showCompleted?: boolean) => {
  const params = showCompleted !== undefined ? { showCompleted } : {};
  return apiInstance.get('/onboarding/business/steps', { params });
};

export const completeOnboardingStep = async (onboardingStepId: string, completed: boolean = true) => {
  return apiInstance.patch('/onboarding/business/complete', {
    onboardingStepId,
    completed,
  });
};
